import { TInputParams } from 'entries/common/widgets/context';
import { ParametersEnum } from '../types';

export const getActiveTab = (filteredInputParams: TInputParams) => {
  const areaParam = filteredInputParams.find(el => el === ParametersEnum.area);
  return areaParam ? 1 : 0;
};
